import type { ComponentType } from 'react';
import {
  BoltIcon,
  BracesIcon,
  BrowserIcon,
  ChipIcon,
  CloudIcon,
  CylinderIcon,
  GridIcon,
  InfinityIcon,
  LayersIcon,
  MonitorIcon,
  PhoneIcon,
  QueryIcon,
  RackIcon,
  ServerIcon,
  TerminalIcon,
  WindowIcon,
  type IconProps,
} from '../components/icons';

export type StackItem = {
  name: string;
  icon: ComponentType<IconProps>;
};

export type StackPanel = {
  /** Window title, styled as a filesystem path. */
  path: string;
  items: readonly StackItem[];
};

/** Original line icons only, never vendor logos (trademark-safe). */
export const stack: readonly StackPanel[] = [
  {
    path: '/srv/apps',
    items: [
      { name: 'Web apps', icon: BrowserIcon },
      { name: 'iOS & watchOS', icon: PhoneIcon },
      { name: 'Cross-platform mobile', icon: MonitorIcon },
      { name: 'REST APIs', icon: ServerIcon },
      { name: 'SaaS platforms', icon: WindowIcon },
    ],
  },
  {
    path: '/usr/lib/languages',
    items: [
      { name: 'TypeScript', icon: BracesIcon },
      { name: 'C# / .NET 9', icon: LayersIcon },
      { name: 'Swift & SwiftUI', icon: BoltIcon },
      { name: 'Python', icon: TerminalIcon },
      { name: 'SQL', icon: QueryIcon },
    ],
  },
  {
    path: '/var/lib/data',
    items: [
      { name: 'PostgreSQL', icon: CylinderIcon },
      { name: 'SQL Server', icon: GridIcon },
      { name: 'Stripe payments', icon: BoltIcon },
      { name: 'Multi-tenant & row-level security', icon: RackIcon },
    ],
  },
  {
    path: '/opt/platform',
    items: [
      { name: 'Google Cloud', icon: CloudIcon },
      { name: 'Docker', icon: LayersIcon },
      { name: 'Linux & nginx', icon: RackIcon },
      { name: 'CI/CD & DevOps', icon: InfinityIcon },
      { name: 'AI & LLM integration', icon: ChipIcon },
    ],
  },
];
